/**
 * Added To Cart Popup App Component
 *
 * Main application component with routing for Added To Cart Popup admin interface.
 *
 * @since 1.0.0
 */

import { SettingsProvider } from '../../contexts/settings-context';
import { ValidationProvider } from '../../contexts/validation-context';
import { AppContent } from '../app-content';

/**
 * Added To Cart Popup App component
 *
 * @since 1.0.0
 *
 * @return JSX element.
 */
export const AddedToCartPopupApp = (): JSX.Element => {
  return (
    <SettingsProvider>
      <ValidationProvider>
        <AppContent />
      </ValidationProvider>
    </SettingsProvider>
  );
};
